<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('waterSet.title') }}</div>
                    </van-col>
                    <van-col span="6">
                        <div class="save" @click="setWater">{{ $t('waterSet.save') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="box">
                <div class="box-item">
                    {{ $t('waterSet.dailyTarget') }}
                    <div class="right" @click="openTargetBox(0)">
                        {{ waterTarget }}
                        ml
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
                <div class="box-item">
                    {{ $t('waterSet.cup') }}
                    <div class="right" @click="openTargetBox(1)">
                        {{ cup }}
                        ml
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
                <div class="box-item">
                    {{ $t('waterSet.reminder') }}
                    <div class="right">
                        <van-switch v-model="isRemind" active-color="var(--chart-color-1)" :size="20 * ratio + 'px'"/>
                    </div>
                </div>
                <div class="box-item" v-if="isRemind">
                    {{ $t('waterSet.reminderStart') }}
                    <div class="right" @click="openTargetBox(2)">
                        {{ startRemind }}
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
                <div class="box-item" v-if="isRemind">
                    {{ $t('waterSet.reminderEnd') }}
                    <div class="right" @click="openTargetBox(3)">
                        {{ endRemind }}
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
                <div class="box-item" v-if="isRemind">
                    {{ $t('waterSet.reminderFrequency') }}
                    <div class="right" @click="openTargetBox(4)">
                        {{ frequencyColumns[remindFrequency] }}
                        <img class="to-img" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
            </div>
            <van-popup v-model="showDaily" round position="bottom">
                <van-picker
                    :title="$t('waterSet.dailyTarget')"
                    show-toolbar
                    :columns="dailyColumns"
                    :default-index="dailyIndex"
                    @cancel="showDaily = false"
                    @confirm="onConfirm"
                />
            </van-popup>
            <van-popup v-model="showCup" round position="bottom">
                <van-picker
                    :title="$t('waterSet.cup')"
                    show-toolbar
                    :columns="cupColumns"
                    :default-index="cupIndex"
                    @cancel="showCup = false"
                    @confirm="onConfirm"
                />
            </van-popup>
            <van-popup v-model="showFrequency" round position="bottom">
                <van-picker
                    :title="$t('waterSet.reminderFrequency')"
                    show-toolbar
                    :columns="frequencyColumns"
                    :default-index="frequencyIndex"
                    @cancel="showFrequency = false"
                    @confirm="onConfirm"
                />
            </van-popup>
            <van-popup v-model="showStart" round position="bottom">
                <van-datetime-picker
                    v-model="startRemind"
                    type="time"
                    :title="$t('waterSet.reminderStart')"
                    @cancel="showStart = false"
                    @confirm="onConfirm"
                />
            </van-popup>
            <van-popup v-model="showEnd" round position="bottom">
                <van-datetime-picker
                    v-model="endRemind"
                    type="time"
                    :title="$t('waterSet.reminderStart')"
                    @cancel="showEnd = false"
                    @confirm="onConfirm"
                />
            </van-popup>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";
import {setUserWater} from "../../api/status";

export default {
    name: '21activeTarget',
    data() {
        return {
            theme: 'light',
            activeType: 0,
            activeTarget: {},
            showDaily: false,
            dailyColumns: [100,
                150,
                200,
                250,
                300,
                350,
                400,
                450,
                500,
                550,
                600,
                650,
                700,
                750,
                800,
                850,
                900,
                950,
                1000,
                1050,
                1100,
                1150,
                1200,
                1250,
                1300,
                1350,
                1400,
                1450,
                1500,
                1550,
                1600,
                1650,
                1700,
                1750,
                1800,
                1850,
                1900,
                1950,
                2000,
                2050,
                2100,
                2150,
                2200,
                2250,
                2300,
                2350,
                2400,
                2450,
                2500,
                2550,
                2600,
                2650,
                2700,
                2750,
                2800,
                2850,
                2900,
                2950,
                3000,
                3050,
                3100,
                3150,
                3200,
                3250,
                3300,
                3350,
                3400,
                3450,
                3500,
                3550,
                3600,
                3650,
                3700,
                3750,
                3800,
                3850,
                3900,
                3950,
                4000,
                4050,
                4100,
                4150,
                4200,
                4250,
                4300,
                4350,
                4400,
                4450,
                4500,
                4550,
                4600,
                4650,
                4700,
                4750,
                4800,
                4850,
                4900,
                4950,
                5000,
                5050,
                5100,
                5150,
                5200,
                5250,
                5300,
                5350,
                5400,
                5450,
                5500,
                5550,
                5600,
                5650,
                5700,
                5750,
                5800,
                5850,
                5900,
                5950,
                6000,
                6050,
                6100,
                6150,
                6200,
                6250,
                6300,
                6350,
                6400,
                6450,
                6500,
                6550,
                6600,
                6650,
                6700,
                6750,
                6800,
                6850,
                6900,
                6950,
                7000,
                7050,
                7100,
                7150,
                7200,
                7250,
                7300,
                7350,
                7400,
                7450,
                7500,
                7550,
                7600,
                7650,
                7700,
                7750,
                7800,
                7850,
                7900,
                7950,
                8000,
                8050,
                8100,
                8150,
                8200,
                8250,
                8300,
                8350,
                8400,
                8450,
                8500,
                8550,
                8600,
                8650,
                8700,
                8750,
                8800,
                8850,
                8900,
                8950,
                9000,
                9050,
                9100,
                9150,
                9200,
                9250,
                9300,
                9350,
                9400,
                9450,
                9500,
                9550,
                9600,
                9650,
                9700,
                9750,
                9800,
                9850,
                9900,
            ],
            dailyIndex: 0,
            showCup: false,
            cupColumns: [25, 50,
                75,
                100,
                125,
                150,
                175,
                200,
                225,
                250,
                275,
                300,
                325,
                350,
                375,
                400,
                425,
                450,
                475,
                500,
                525,
                550,
                575,
                600,
                625,
                650,
                675,
                700,
                725,
                750,
                775,
                800,
                825,
                850,
                875,
                900,
                925,
                950,
                975,
                1000,
                1025,
                1050,
                1075,
                1100,
                1125,
                1150,
                1175,
                1200,
                1225,
                1250,
                1275,
                1300,
                1325,
                1350,
                1375,
                1400,
                1425,
                1450,
                1475,
                1500,
                1525,
                1550,
                1575,
                1600,
                1625,
                1650,
                1675,
                1700,
                1725,
                1750,
                1775,
                1800,
                1825,
                1850,
                1875,
                1900,
                1925,
                1950,
                1975,
                2000,
                2025,
                2050,
                2075,
                2100,
                2125,
                2150,
                2175,
                2200,
                2225,
                2250,
                2275,
                2300,
                2325,
                2350,
                2375,
                2400,
                2425,
                2450,
                2475,
                2500,
                2525,
                2550,
                2575,
                2600,
                2625,
                2650,
                2675,
                2700,
                2725,
                2750,
                2775,
                2800,
                2825,
                2850,
                2875,
                2900,
                2925,
                2950,
                2975
            ],
            cupIndex: 0,
            isRemind: 0,
            startRemind: '08:00',
            endRemind: '20:00',
            remindFrequency: 0,
            showFrequency: false,
            frequencyColumns: [this.$t('waterSet.frequency0'), this.$t('waterSet.frequency1'), this.$t('waterSet.frequency2')],
            frequencyIndex: 0,
            waterTarget: 1000,
            cup: 250,
            ratio: 1,
            showStart: false,
            showEnd: false,
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
        this.getUserWaterSet();
    },
    methods: {
        getUserWaterSet() {
            this.$api.status.getUserWaterSet().then(res => {
                this.waterTarget = res.info.waterTarget
                this.cup = res.info.onceWaterCount
                this.isRemind = !!res.info.isRemind
                this.startRemind = res.info.startWaterTime
                this.endRemind = res.info.endWaterTime
                this.remindFrequency = res.info.remindFreq
            })
        },
        back() {
            this.$router.back()
        },
        openTargetBox(activeType) {
            this.activeType = activeType
            if (activeType == 0) {
                this.dailyIndex = (this.waterTarget - 100) / 50
                this.showDaily = true
            } else if (activeType == 1) {
                this.cupIndex = (this.cup - 25) / 25
                this.showCup = true
            } else if (activeType == 2) {
                this.showStart = true
            } else if (activeType == 3) {
                this.showEnd = true
            } else if (activeType == 4) {
                this.showFrequency = true
            }
        },
        onConfirm(value, index) {
            if (this.activeType == 0) {
                this.waterTarget = value
                this.dailyIndex = index
                this.showDaily = false
            } else if (this.activeType == 1) {
                this.cup = value
                this.cupIndex = index
                this.showCup = false
            } else if (this.activeType == 2) {
                this.showStart = false
            } else if (this.activeType == 3) {
                this.showEnd = false
            } else {
                this.remindFrequency = index
                this.frequencyIndex = index
                this.showFrequency = false
            }
        },
        setWater() {
            this.$api.status.setUserWater({
                waterTarget: this.waterTarget,
                userWaterCount: this.cup,
                isRemind: this.isRemind ? 1 : 0,
                startWaterTime: this.startRemind,
                endWaterTime: this.endRemind,
                remindFreq: this.remindFrequency
            }).then(res => {
                this.$toast.success(this.$t('waterSet.success'))
                WebJSBridge.call('setUserWater', {
                    waterTarget: this.waterTarget,
                    userWaterCount: this.cup,
                    isRemind: this.isRemind ? 1 : 0,
                    startWaterTime: this.startRemind,
                    endWaterTime: this.endRemind,
                    remindFreq: this.remindFrequency
                }, (res) => {
                })
            })
        }
    }
}
</script>
<style scoped>
.box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 11px auto;
    padding-bottom: 20px;
}

.box-item {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    color: var(--text-color-1);
    width: 315px;
    margin: 0 auto;
    padding-top: 22px;
}

.right {
    color: var(--text-color-2);
    display: flex;
    align-items: center;
}

.to-img {
    width: 16px;
}


/deep/ .van-picker {
    background-color: var(--bg-color-2);
    color: var(--text-color-1);
}

/deep/ .van-picker__mask {
    background-image: none;
}

/deep/ .van-picker-column__item {
    color: var(--text-color-1);
    font-size: 10px;
}

/deep/ .van-picker__confirm {
    color: #22ACFB;
    font-size: 17px;
}

/deep/ .van-picker__cancel {
    font-size: 17px;
    color: var(--text-color-2);
}

/deep/ .van-picker__title {
    font-size: 17px;
}

/deep/ .van-picker-column__item {
    font-size: 16px;
}

/deep/ .van-picker-column__item--selected {
    font-size: 20px;
}

.save {
    font-size: 15px;
    color: var(--chart-color-1);
    text-align: right;
    margin: 13px 19px;
    line-height: 19px;
}
</style>


// WEBPACK FOOTER //
// src/views/status/18waterSet.vue